// todo translate
import React from "react";
import differenceInDays from "date-fns/differenceInDays";

import { Typography, Tooltip } from "@mui/material";

import { intlFormatDateShort } from "../../../../utils/time-utils";

import { Props } from "./interfaces";
import { RootContainer } from "./styles";

const DAYS_DIFF_CHECK_FUTURE = 30;
const DAYS_DIFF_CHECK_PAST = 30;

const Deadline = ({ deadline, hasDocuments, lastAddedDate, periodType, offset }: Props) => {
  const hasDeadline = !!deadline;
  const theDeadline = deadline ? new Date(deadline) : new Date();
  const theLastAddedDate = lastAddedDate ? new Date(lastAddedDate) : new Date();
  const diffWithToday = hasDeadline ? differenceInDays(theDeadline, Date.now()) : 0;
  const diffWithLastAdded = hasDocuments ? differenceInDays(theDeadline, theLastAddedDate) : 0;

  const textFarPastOrFuture = `Due on ${intlFormatDateShort(theDeadline)}`;
  const textNearestFuture = `Due in ${diffWithToday} day${Math.abs(diffWithToday) - 1 > 0 ? "s" : ""}`;
  const textLatelyPast = `Late ${Math.abs(diffWithToday)} day${Math.abs(diffWithToday) - 1 > 0 ? "s" : ""}`;

  let titleText = "";
  // show title only for past and only if docs were uploaded late
  if (hasDeadline && diffWithToday < 0 && hasDocuments && diffWithLastAdded < 0) {
    titleText = `Uploaded ${Math.abs(diffWithLastAdded)} day${Math.abs(diffWithLastAdded) - 1 > 0 ? "s" : ""} late`;
  } else if (hasDeadline) {
    titleText = `${periodType}+${offset}`;
  }

  let deadlineText = "";
  if (hasDeadline) {
    if (diffWithToday < 0) {
      if (diffWithToday < -DAYS_DIFF_CHECK_PAST) {
        deadlineText = textFarPastOrFuture;
      } else {
        deadlineText = textLatelyPast;
        titleText = `${titleText}: before ${intlFormatDateShort(theDeadline)}`;
      }
    } else {
      if (diffWithToday <= DAYS_DIFF_CHECK_FUTURE) {
        deadlineText = textNearestFuture;
        titleText = `${titleText}: before ${intlFormatDateShort(theDeadline)}`;
      } else {
        deadlineText = textNearestFuture;
        titleText = `${titleText}: before ${intlFormatDateShort(theDeadline)}`;
      }
    }
  }

  return (
    <>
      {hasDeadline && (
        <RootContainer
          showDeadline={
            !hasDocuments && diffWithToday <= DAYS_DIFF_CHECK_FUTURE && diffWithToday >= -DAYS_DIFF_CHECK_PAST
          }
          isDeadlineLate={hasDocuments && diffWithToday <= 0 && diffWithLastAdded < 0}
        >
          <Tooltip title={titleText}>
            <Typography>{deadlineText}</Typography>
          </Tooltip>
        </RootContainer>
      )}
    </>
  );
};

export default Deadline;
